class MenuLink extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("mouseenter", (event) => {
      const existingSelector = document.querySelectorAll(
        '[id^="menu-child-color-"]'
      );

      existingSelector.forEach((item) => {
        item.style.display = "none";
      });

      const selectorLink = document.querySelectorAll(
        "#menu-child-color-" + event.target.id
      );

      selectorLink.forEach((item) => {
        item.style.display = "block";
      });
    });
  }
}

customElements.define("menu-link", MenuLink);
